module.exports = __webpack_public_path__ + "static/media/details-11-image-3.43ba868c.jpg";